import {
  Button,
  FileUpload,
  SelectDropDown,
  TextField,
} from '@/components/Common';
import {
  IconPosition,
  TextfieldType,
} from '@/components/Common/TextField/TextField.types';
import { FieldError } from 'react-hook-form';
import { Calendar } from '@/components/Common/Calendar/Calendar';
import { Modal } from '@/components/Layout';
import { useCampaigne } from './campaigne.hook';
import iconBanner from '@/assets/icons/banner.svg';
import ic_image from '@/assets/icons/ic_image.svg';
import moneyIcon from '@/assets/icons/money.svg';
import positionIcon from '@/assets/icons/position.svg';
import solarLink from '@/assets/icons/solar_link.svg';
import { useId } from 'react';
import { CampaignType } from '@/api/gql/graphql';
import dateIcon from '@/assets/icons/date.svg';

export const CampaignForm = () => {
  const {
    companies,
    bannerTypeOptions,
    durationOptions,
    campaignType,
    handleChangeCampaignType,
    handleChangeCompany,
    handleChangeDuration,
    handleChangePriority,
    priorityOptions,
    onSubmit,
    isOpenCampaignModal,
    register,
    handleSubmit,
    setValue,
    errors,
    addCompanyLoading,
    generateUrlLoading,
    handleCloseModal,
  } = useCampaigne();
  const id = useId();
  
  return (
    <Modal
      isOpen={isOpenCampaignModal}
      onClose={handleCloseModal}
      headerStyle="bg-[#2A2A2A] h-[36px]"
      modalStyle="bg-[#2A2A2A]"
    >
      <div className="flex flex-col justify-center items-center mb-7">
        <span className="text-xl text-primary font-bold">
          Lancer une campagne
        </span>
        <span className="text-xs text-[#9FA9B2] font-normal">
          Information sur la compagne
        </span>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="w-[653px]">
        <TextField
          placeholder="Nom de la campagne"
          register={register('campaignName')}
          helpText={(errors.campaignName as FieldError)?.message}
          errorStyle="text-red-500 text-xs"
          textFieldType={TextfieldType.INPUT}
          className="!bg-[#232323] text-xs text-[#949494] font-normal"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mt-2">
          {/* Colonne gauche */}
          <div className="space-y-4">
            <div className="h-[60px]">
              <SelectDropDown
                options={bannerTypeOptions}
                icon={<img src={iconBanner} alt="banner" />}
                placeholder="Type de campagne"
                name="campaignType"
                handleChange={handleChangeCampaignType}
                setValue={setValue}
                helpText={(errors.campaignType as FieldError)?.message}
                errorStyle="text-red-500 text-xs"
                className="!text-[#949494] font-normal"
              />
            </div>
            <div className="h-[60px]">
              <SelectDropDown
                icon={<i className="pi pi-building" />}
                options={companies || []}
                placeholder="Nom de l'entreprise"
                name="company"
                handleChange={handleChangeCompany}
                setValue={setValue}
                helpText={(errors.company as FieldError)?.message}
                errorStyle="text-red-500 text-xs"
                selectDropDownStyle={{
                  backgroundColor: '#232323',
                  fontSize: '12px',
                }}
              />
            </div>
            <div className="flex justify-between gap-x-2 h-[60px]">
              <Calendar
                name="campaignStartDate"
                label="Date de début"
                setValue={setValue}
                helpText={errors.campaignStartDate?.message}
                errorStyle="text-red-500 text-xs"
                minDate={new Date()}
                className="w-[175px] bg-[#232323] text-[12px] text-[#949494] font-normal"
                dateIcon={dateIcon}
              />

              <SelectDropDown
                options={durationOptions}
                placeholder="Durée"
                icon={<i className="pi pi-calendar-clock" />}
                name="campaignDuration"
                handleChange={handleChangeDuration}
                setValue={setValue}
                helpText={(errors.campaignDuration as FieldError)?.message}
                errorStyle="text-red-500 text-xs w-[100%]"
                selectDropDownStyle={{ width: '100%', fontSize: '12px' }}
              />
            </div>

            <div className="h-[60px]">
              <TextField
                placeholder="Montant"
                register={register('campaignAmount')}
                helpText={(errors.campaignAmount as FieldError)?.message}
                errorStyle="text-red-500 text-xs"
                textFieldType={TextfieldType.INPUT}
                className="!bg-[#232323] text-xs text-[#949494] font-normal"
                borderStyle="!bg-[#232323] px-3"
                icon={<img src={moneyIcon} alt="money" />}
                iconPosition={IconPosition.LEFT}
              />
            </div>
          </div>

          {/* Colonne droite */}
          <div className="space-y-4">
            <div className="h-[60px]">
              <SelectDropDown
                options={priorityOptions}
                icon={<img src={positionIcon} alt="position" />}
                placeholder={campaignType?._id === CampaignType.MainBanner ? 'Position' : 'Priorité'}
                name="campaignPriority"
                handleChange={handleChangePriority}
                setValue={setValue}
                helpText={(errors.campaignPriority as FieldError)?.message}
                errorStyle="text-red-500 text-xs"
                selectDropDownStyle={{ fontSize: '12px' }}
              />
            </div>

            <div className="h-[60px]">
              <FileUpload
                id={`${id}-image`}
                icon={<img src={ic_image} alt="image" />}
                placeholder="Image"
                name="campaignResource"
                setValue={setValue}
                errorStyle="text-red-500 text-xs"
                helpText={
                  (CampaignType.AudioPreLesson !== campaignType?._id
                    ? (errors.campaignResource as FieldError)
                    : null
                  )?.message
                }
                allowedFileTypes={['image/png', 'image/jpeg', 'image/jpg']}
                disabled={!(CampaignType.AudioPreLesson !== campaignType?._id)}
                fileUploadStyle={
                  CampaignType.AudioPreLesson !== campaignType?._id
                    ? 'bg-[#232323]'
                    : 'bg-[#272727]'
                }
              />
            </div>

            <div className="h-[60px]">
              <FileUpload
                id={`${id}-audio`}
                icon={<i className="pi pi-headphones" />}
                placeholder="Audio"
                name="campaignResource"
                setValue={setValue}
                errorStyle="text-red-500 text-xs"
                helpText={
                  (CampaignType.AudioPreLesson === campaignType?._id
                    ? (errors.campaignResource as FieldError)
                    : null
                  )?.message
                }
                allowedFileTypes={['audio/mpeg', 'audio/mp3']}
                disabled={
                  !(campaignType?._id !== undefined &&
                  CampaignType.AudioPreLesson === campaignType?._id)
                }
                fileUploadStyle={
                  campaignType?._id !== undefined &&
                  CampaignType.AudioPreLesson === campaignType?._id
                    ? 'bg-[#232323]'
                    : 'bg-[#272727]'
                }
              />
            </div>
              
            <div className="h-[60px]">
              <TextField
                placeholder="Lien"
                name="campaignLink"
                register={register('campaignLink')}
                helpText={(errors.campaignLink as FieldError)?.message}
                errorStyle="text-red-500 text-xs"
                textFieldType={TextfieldType.INPUT}
                className="!bg-[#232323]"
                icon={<img src={solarLink} alt="link" />}
                iconPosition={IconPosition.LEFT}
                borderStyle={'!bg-[#232323] px-3'}
              />
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-6">
          <Button
            type="submit"
            title={
              addCompanyLoading || generateUrlLoading
                ? 'En cours...'
                : 'Lancer la campagne'
            }
            disabled={addCompanyLoading || generateUrlLoading}
            className="py-2 px-6 rounded-lg w-[308px]"
          />
        </div>
      </form>
    </Modal>
  );
};
